import { render, staticRenderFns } from "./view-plans.vue?vue&type=template&id=380192ae&scoped=true"
import script from "./view-plans.vue?vue&type=script&lang=js"
export * from "./view-plans.vue?vue&type=script&lang=js"
import style0 from "./view-plans.vue?vue&type=style&index=0&id=380192ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380192ae",
  null
  
)

export default component.exports